import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { login } from './components/login';
import { relic } from './components/relic';
import { report } from './components/report';
import { gis } from './components/gis';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    login,
    relic,
    report,
    gis
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      paths: [
        'login.authToken',
        'login.userInfo',
        'login.authorizationLimit',
        'login.limitShow',
        'login.minioOption'
      ]
    })
  ]
});
